export default {
  unavailable: {
    title: 'Toegang tot self-serve partners is beperkt',
    description:
      'Dit gedeelte is niet beschikbaar voor partners met selfservice-onboarding. Neem contact op met uw accountmanager als u het nodig heeft.',
  },
};
